// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const AdaptiveScanningObservationSourceSchema = z.enum(['neo','crawl','das'] as const);

export type AdaptiveScanningObservationSourceType = `${z.infer<typeof AdaptiveScanningObservationSourceSchema>}`

export default AdaptiveScanningObservationSourceSchema;
